import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const sceneManagementService = {
  //分页查询场景
  getList(params) {
    return request({
      url: REST_SERVICE.scene.sceneGetByPage,
      method: 'get',
      params,
    });
  },
  // 添加场景
  sceneAdd(params) {
    return request({
      url: REST_SERVICE.scene.sceneAdd,
      method: 'post',
      data: params,
    });
  },
  // 根据id修改场景
  sceneUpdateById(params) {
    return request({
      url: REST_SERVICE.scene.sceneUpdateById,
      method: 'post',
      data: params,
    });
  },
  // 根据id删除场景
  sceneDeleteById(params) {
    return request({
      url: REST_SERVICE.scene.sceneDeleteById,
      method: 'post',
      data: params,
    });
  },
  // 批量绑定规则的功能
  sceneBindRuleList(params) {
    return request({
      url: REST_SERVICE.scene.sceneBindRuleList,
      method: 'posts',
      data: params,
    });
  },
  // 场景中显示已绑定规则和未绑定规则分页的功能
  sceneBindRuleByPage(params) {
    return request({
      url: REST_SERVICE.scene.sceneBindRuleByPage,
      method: 'get',
      params,
    });
  },
  // 批量取消绑定的功能
  sceneUnBindRuleList(params) {
    return request({
      url: REST_SERVICE.scene.sceneUnBindRuleList,
      method: 'posts',
      data: params,
    });
  },
  // 通过场景id校验场景的语句
  sceneCheckDrl(params) {
    return request({
      url: REST_SERVICE.scene.sceneCheckDrl,
      method: 'get',
      params,
    });
  },
};
export default sceneManagementService;
